import { useState } from "react";
import { ArrowRight, Loader2, Search } from "lucide-react";
import { toast } from "sonner";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

export const DomainForm = ({
  onAnalyze,
  loading,
  testid = "domain-form",
  inputTestId = "domain-input",
  submitTestId = "analyze-submit",
  size = "lg",
}) => {
  const [domain, setDomain] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const val = domain.trim();
    if (!val || val.length < 2) {
      toast.error(t("domain.error"));
      return;
    }
    onAnalyze(val);
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid={testid}>
      <div className="flex flex-col sm:flex-row items-stretch gap-3 sm:gap-0 border-2 border-obsidian bg-white sm:shadow-[6px_6px_0px_0px_rgba(10,10,10,1)]">
        <div className={`flex items-center flex-1 px-4 border-b-2 sm:border-b-0 ${HE ? "sm:border-l-2" : "sm:border-r-2"} border-obsidian`}>
          <Search className="h-5 w-5 text-neutral-400 shrink-0" />
          <input
            type="text"
            dir="auto"
            placeholder={t("domain.placeholder")}
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            className={`w-full bg-transparent font-data ${size === "lg" ? "text-lg py-5" : "text-base py-4"} px-3 focus:outline-none placeholder:text-neutral-400`}
            data-testid={inputTestId}
            autoComplete="off"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-conversion text-white font-bold uppercase tracking-wide px-7 py-4 sm:py-5 flex items-center justify-center gap-2 transition-colors hover:bg-conversion-hover disabled:opacity-70"
          data-testid={submitTestId}
        >
          {loading ? (
            <><Loader2 className="h-5 w-5 animate-spin" /> {t("domain.scanning")}</>
          ) : (
            <>{t("domain.button")} <ArrowRight className={`h-5 w-5 ${HE ? "rotate-180" : ""}`} /></>
          )}
        </button>
      </div>
      <p className="mt-2 text-xs text-neutral-600">{t("domain.hint")}</p>
    </form>
  );
};

export default DomainForm;
